import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    // myAdditionalText: string, // Example
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const medicalMessagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    verificationPurposesOnly: '(Used for verification purposes only)',
    emailExplanation: '(Needed to send you your unique code)',
    infoShared: 'Information entered here will be used for verification purposes and shared with Awara.',
    verifyMyMedicalProfessionalStatus: 'VERIFY MY MEDICAL PROFESSIONAL STATUS',
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status selector of this form.<br><br>Awara uses SheerID, a trusted partner, to verify that you are a medical professional. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.',
        },
        docUpload: {
            submitButtonLabel: 'SUBMIT',
            cancelButtonLabel: 'CANCEL',
            howDoesVerifyingWorkDetails: 'Document review is handled by SheerID, a trusted partner who specializes in verifying medical professionals.<br><br>Documents are used only for verifying your medical professional status is current and will be permanently deleted after review is finalized. They will not be shared with Awara.',
        },
        success: {
            redirectUrl: 'https://www.awarasleep.com/products/mattress/discounts/',
            verificationOnly: `
            SheerID handles verification only.
            Now that you've been approved, please direct all questions about the
            promotion terms and/or code use to Awara customer service.`,
            subtitle: 'Here is your personal coupon code.<br>It is unique to you and can only be used once.',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later.<br>Look for the email from verify@sheerid.com.',
        },
        pending: {
            subtitle2:
               'This process may take up to 20 minutes.<br>Wait here or let us notify you of the outcome.<br>You will be contacted via email.',
            subtitle3: ' ',
        },
    },
};
